<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-05 19:07:50
-->
<template>
	<div class="search">
		<el-form :inline="true" :model="formData" class="demo-form-inline form-flex" label-width="100px">
			<div class="search-box">
				<el-form-item label="商品名称：" :label-width="labelWidth">
					<el-input v-model="formData['product_name']" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="商品ID：" :label-width="labelWidth">
					<el-input v-model="formData['product_id']" placeholder="请输入商品ID"></el-input>
				</el-form-item>
				<el-form-item label="店铺名称：" :label-width="labelWidth">
					<el-input v-model="formData['shop_name']" placeholder="请输入店铺名称"></el-input>
				</el-form-item>
				<el-form-item label="推广状态：" :label-width="labelWidth">
					<el-select v-model="formData['other_status']" clearable placeholder="请选择推广状态">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in promoteText" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="佣金率：" :label-width="labelWidth">
					<div class="flex">
						<el-input v-model="formData['from_commission_rate']" placeholder="最小值" class="input_width"></el-input>
						<span class="ml-10 mr-10">至</span>
						<el-input v-model="formData['to_commission_rate']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="直播价：" :label-width="labelWidth">
					<div class="flex">
						<el-input v-model="formData['from_live_price']" placeholder="最小值" class="input_width"></el-input>
						<span class="ml-10 mr-10">至</span>
						<el-input v-model="formData['to_live_price']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="现售价：" :label-width="labelWidth">
					<div class="flex">
						<el-input v-model="formData['from_sale_price']" placeholder="最小值" class="input_width"></el-input>
						<span class="ml-10 mr-10">至</span>
						<el-input v-model="formData['to_sale_price']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="服务费率：" :label-width="labelWidth" v-if="$auth.hasPermi('system:goods-ServiceRate')">
					<div class="flex">
						<el-input v-model="formData['from_service_rate']" placeholder="最小值" class="input_width"></el-input>
						<span class="ml-10 mr-10">至</span>
						<el-input v-model="formData['to_service_rate']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<template v-if="$isKs()">
					<el-form-item label="推广者信息：" prop="contact_user_type">
						<el-select v-model="formData.contact_user_type" clearable placeholder="请选择">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in contactUserTypeArr" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</template>
			</div>
		</el-form>
		<div class="search-btn">
			<el-button type="primary" @click="onSubmit">筛选</el-button>
			<el-button @click="onClear">清空</el-button>
		</div>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'search',
	props: {
		platformId: {
			type: [String, Number],
			default: '1',
		},
	},
	components: {},
	data() {
		return {
			formData: {},
			freeOrderTime: '',
			labelWidth: '100px',
			promoteText: [
				{
					label: '推广中',
					value: 1,
				},
				{
					label: '已失效-商品下架',
					value: 2,
				},
				{
					label: '已失效-活动失效',
					value: 3,
				},
				{
					label: '暂停推广',
					value: 4,
				},
				{
					label: '待生效',
					value: 5,
				},
			],
			contactUserTypeArr: [
				{
					label: '全部',
					value: '0',
				},
				{
					label: '团长',
					value: '1',
				},
				{
					label: '团长 + 达人',
					value: '3',
				},
			],
		};
	},
	computed: {},
	methods: {
		onClear() {
			this.formData = {};
			this.freeOrderTime = '';
			this.onSubmit();
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.from_time = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData.to_time = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style scoped></style>
<style lang="less" scoped>
.search {
	padding: 24px 30px;
	background-color: #f8f8f8;
}

.search-box {
	width: 100%;
	margin: 0 auto;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 0.5rem;
}

.search-btn {
	margin-left: 100px;
}

.input_width {
	width: 100px;
}
</style>
